import { render, staticRenderFns } from "./BusinessPlanAgreement.vue?vue&type=template&id=4925cb6a&"
import script from "./BusinessPlanAgreement.vue?vue&type=script&lang=js&"
export * from "./BusinessPlanAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports